import type { RouteRecordRaw } from 'vue-router';
import { TURN_TRACKER_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const turnTrackerRoutes: RouteRecordRaw = {
  path: '/turn-tracker',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: TURN_TRACKER_ROUTE_NAME.TURN_TRACKER,
      path: '',
      component: () => import('./TurnTracker.vue'),
      meta: {
        requireAuth: true,
      },
    },
  ],
};
